import React from 'react';

/**
 * Compact toggle switch matching the Reddit Hub system design
 * (same track/knob styling as the "Instant Deletion" toggle in RedditorDashboard).
 *
 * Props:
 *   checked   — boolean, current on/off state
 *   onChange  — (next: boolean) => void
 *   onLabel   — text shown when checked (the action clicking will perform)
 *   offLabel  — text shown when unchecked
 *   title     — optional tooltip
 */
export default function ArchiveToggle({ checked, onChange, onLabel, offLabel, title }) {
  return (
    <button
      type="button"
      title={title}
      onClick={() => onChange(!checked)}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 8,
        background: 'none', border: 'none', padding: 0,
        cursor: 'pointer', fontFamily: 'inherit',
        whiteSpace: 'nowrap',
      }}
    >
      <span style={{
        fontSize: '0.8rem', fontWeight: 600,
        color: checked ? '#c2410c' : 'var(--rh-text-muted)',
        transition: 'color 0.15s',
      }}>
        {checked ? onLabel : offLabel}
      </span>
      <span
        aria-hidden
        style={{
          width: 36, height: 20, borderRadius: 10, position: 'relative', flexShrink: 0,
          background: checked ? '#f97316' : '#d1d5db',
          transition: 'background 0.2s',
        }}
      >
        <span style={{
          position: 'absolute', top: 2, left: checked ? 18 : 2,
          width: 16, height: 16, borderRadius: '50%', background: '#fff',
          boxShadow: '0 1px 3px rgba(0,0,0,0.2)', transition: 'left 0.2s',
        }} />
      </span>
    </button>
  );
}
